// Report-param token grammar for the polarity-scale block: psc<key> = <mode>[!n<neutral>].
// Ported from the coffee block (importReportParams / updateReportParams); the defaults both
// sides compare against come from the authoring format, falling back to the block defaults.

import {
  MODE_CONVERSION_CHART,
  MODE_DEFAULT,
  MODE_TYPES,
  NEUTRAL_DEFAULT
} from '@aytm/app/stats/page/question-views/psc/lib/constants'

const NEUTRAL_PREFIX = 'n'

const calcDefaults = (format = {}) => ({
  mode: (format.mode && MODE_CONVERSION_CHART[format.mode]) || MODE_DEFAULT,
  neutral: format.neutral || NEUTRAL_DEFAULT
})

// Resolves the state the block starts from. `needsUpdate` marks a token the block cannot read,
// so the caller rewrites it from the defaults.
export const resolveReportParams = ({ section, format = {} } = {}) => {
  const defaults = calcDefaults(format)

  const [mode, neutralPart] = String(section || defaults.mode).split('!')

  if (!Object.hasOwn(MODE_TYPES, mode)) return { state: defaults, needsUpdate: true }

  let neutral = defaults.neutral
  if (undefined !== neutralPart && NEUTRAL_PREFIX === neutralPart[0]) {
    const parsed = parseInt(neutralPart.slice(1), 10)
    // a digitless suffix (e.g. "!n") must not store NaN
    neutral = Number.isNaN(parsed) ? defaults.neutral : parsed
  }

  return { state: { mode, neutral }, needsUpdate: false }
}

// The psc<key> token to persist, or null once the state is back at the block defaults.
export const calcReportParamsSection = ({ mode, neutral, format = {} } = {}) => {
  const defaults = calcDefaults(format)

  if (mode === defaults.mode && neutral === defaults.neutral) return null

  return neutral === defaults.neutral ? mode : `${mode}!${NEUTRAL_PREFIX}${neutral}`
}
